// extracted by mini-css-extract-plugin
export default {"tLogo1":"Logo_tLogo1__nDUYh","logo":"Logo_logo__329O6"};